import TextField from '@mui/material/TextField';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import React from 'react';
import { observer } from 'mobx-react';
import { useTheme } from '@mui/material/styles';
import { TTreeItemDataViewModel } from '../../services/models/CourseViewModels';
import useEditablePageTitle from './useEditablePageTitle';

interface IPageNavigationTitleProps {
  className?: string;
  data: TTreeItemDataViewModel;
  fontSize?: number;
  onFocus?: (e: any) => void;
}

export default observer(function PageNavigationTitle({ data, className, fontSize = 14, onFocus }: IPageNavigationTitleProps) {
  const theme = useTheme();
  const { editTitleMode, isTitleTruncated, titleMeasureRef, onTitleChange, updateTitle, handleOnKeyDown, handleOnClick, handleOnDoubleClick, handleTextFieldClick, handleOnFocus } =
    useEditablePageTitle({
      data,
      fontSize,
      onFocus,
    });

  return !editTitleMode ? (
    <div onClick={handleOnClick} onDoubleClick={handleOnDoubleClick} style={{ minWidth: 100, minHeight: 20, cursor: 'text' }}>
      <Tooltip
        title={data.title?.value ?? ''}
        disableHoverListener={!isTitleTruncated}
        disableFocusListener={!isTitleTruncated}
        disableTouchListener={!isTitleTruncated}
        arrow
      >
        <Typography ref={titleMeasureRef} component='span' variant='body2' fontSize={fontSize} className={className} noWrap style={{ textAlign: 'center', maxWidth: '700px', display: 'block' }}>
          {data.title?.value}
        </Typography>
      </Tooltip>
    </div>
  ) : (
    <TextField
      data-pagetour='2'
      variant='standard'
      size='small'
      inputProps={{ style: { fontSize: fontSize } }}
      hiddenLabel={true}
      defaultValue={data.title?.value}
      onClick={handleTextFieldClick}
      onDoubleClick={handleTextFieldClick}
      onFocusCapture={handleOnFocus}
      onChange={(e: any) => onTitleChange(e.target?.value)}
      onKeyDown={handleOnKeyDown}
      onBlur={updateTitle}
      fullWidth
      autoFocus
      className={className}
      onFocus={(event) => {
        event.target.select();
      }}
      sx={{ input: { color: theme.palette.common.white } }}
    />
  );
});
